// The boot: the first thing the page does is read the platform profile at its
// own origin, and it refuses to start without one (02-DESIGN/03-console/
// 01-the-console.md § no backend). Nothing else runs before that answer. The
// fonts are bundled with the page, never fetched from elsewhere.

import "@fontsource-variable/geist";
import "@fontsource-variable/geist-mono";
import { createRoot } from "react-dom/client";

import { App } from "./app.tsx";
import { readPlatform } from "./platform/profile.ts";
import { Entry } from "./surfaces/entry/Entry.tsx";
import { describe } from "./ui/components.tsx";
import "./ui/base.css";

const container = document.getElementById("root");
if (container === null) {
  throw new Error("no root element");
}
const root = createRoot(container);
const origin = window.location.origin;

root.render(
  <Entry>
    <p className="faint" aria-busy="true">
      Starting…
    </p>
  </Entry>,
);

readPlatform(origin).then(
  (platform) => {
    root.render(<App origin={origin} platform={platform} />);
  },
  (err: unknown) => {
    root.render(
      <Entry>
        <div className="entry-card">
          <h1>This console cannot start</h1>
          <p className="lead">
            The page read no platform profile at its own origin, so it does not know which environment it
            belongs to and refuses to guess.
          </p>
          <p className="small bad">{describe(err)}</p>
          <p className="small faint" style={{ marginTop: 12 }}>
            The install&apos;s web server serves the profile at <code>/.well-known/impire/platform.json</code>{" "}
            beside this bundle.
          </p>
        </div>
      </Entry>,
    );
  },
);
